import Cookie from 'js-cookie';
import { useEffect, useState } from 'react';

/**
 * Einwilligung fuer externe Dienste.
 *
 * Bisher setzte der Cookie-Hinweis nur ein Cookie, ohne dass irgendetwas davon
 * abhing - die Google-Maps-Karte auf der Kontaktseite lud in jedem Fall und
 * uebertrug dabei die IP-Adresse der Besucher an Google. Jetzt haengt das
 * Laden der Karte an dieser Einwilligung.
 *
 * Der Zustand liegt in einem Cookie, ist also erst im Browser bekannt. Die
 * Seiten werden statisch erzeugt; Bestandteile, die von der Einwilligung
 * abhaengen, muessen deshalb nach dem ersten Rendern entschieden werden.
 */

const COOKIE_NAME = 'cookieConsent';
const EREIGNIS = 'einwilligung-geaendert';

export const ZUGESTIMMT = 'accepted';
export const ABGELEHNT = 'rejected';

/** @returns {'accepted'|'rejected'|null} null = noch nicht entschieden */
export function einwilligungLesen() {
  if (typeof document === 'undefined') return null;
  return Cookie.get(COOKIE_NAME) ?? null;
}

export function einwilligungSetzen(wert) {
  Cookie.set(COOKIE_NAME, wert, {
    // Zustimmung ein Jahr, Ablehnung nur einen Tag - so wird spaeter erneut
    // gefragt, ohne die Ablehnung sofort zu vergessen.
    expires: wert === ZUGESTIMMT ? 365 : 1,
    path: '/',
    // Auf http (lokale Entwicklung) wuerde ein secure-Cookie verworfen.
    secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
    sameSite: 'Strict',
  });
  window.dispatchEvent(new Event(EREIGNIS));
}

/**
 * Aktueller Einwilligungsstand, reagiert auf Aenderungen im selben Tab.
 *
 * Beim ersten Rendern immer null, damit Server und Browser dasselbe ausgeben
 * und React nicht ueber abweichendes Markup stolpert.
 */
export function useEinwilligung() {
  const [wert, setWert] = useState(null);

  useEffect(() => {
    const lesen = () => setWert(einwilligungLesen());
    lesen();
    window.addEventListener(EREIGNIS, lesen);
    return () => window.removeEventListener(EREIGNIS, lesen);
  }, []);

  return wert;
}
